import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
} from '@progress/kendo-react-layout';
import { isCanada } from 'app/common/websiteCountry';
import some from 'lodash/some';
import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NotificationsTopRight } from '../NotificationsTopRight';
import { ProfileTopRight } from '../ProfileTopRight';
import { LayoutContext } from '../ReactContexts/layoutContext';
import { LanguageSwitcher } from 'app/components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context';
import clsx from 'clsx';

export function KubotaAppBar() {
  const { classNames, setClassNames, removeSpecificClass } =
    React.useContext(LayoutContext);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (!some(classNames, cls => cls.class === 'mobile-nav-shown')) {
      setClassNames('mobile-nav-shown');
    } else {
      removeSpecificClass('mobile-nav-shown');
    }
  };

  function handleLogoClick() {
    if (isAuthenticated) {
      navigate('/equipment');
    } else {
      navigate('/login');
    }

    handleClick();
  }

  return (
    <AppBar className={`${isCanada ? 'website-CA' : ''} appbar-nav`}>
      <AppBarSection className="appbar-nav-toggle-section">
        <span className="mobile-menu-toggle" onClick={handleClick}>
          <svg
            id="ic_menu_hamburger"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <rect id="Box" width="32" height="32" fill="none" />
            <line
              id="Line"
              x2="20"
              transform="translate(6 8.5)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line-2"
              data-name="Line"
              x2="20"
              transform="translate(6 23.5)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line-3"
              data-name="Line"
              x2="20"
              transform="translate(6 16)"
              fill="none"
              stroke="#1a1a1a"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </svg>
        </span>
      </AppBarSection>
      <AppBarSection className="appbar-logo-section">
        <span
          className={clsx('site-logo', { 'website-CA': isCanada })}
          onClick={handleLogoClick}
        >
          <img src="/logo.svg" alt="logo" />
        </span>
      </AppBarSection>
      <AppBarSpacer className="appbar-spacer" />

      {isAuthenticated && (
        <>
          <AppBarSection>
            <NotificationsTopRight />
          </AppBarSection>

          <AppBarSection>
            <ProfileTopRight />
          </AppBarSection>
        </>
      )}

      {!isAuthenticated && (
        <>
          <AppBarSection>
            <Link className="sign-in-link" to="/login">
              {t('sign_in')}
            </Link>
          </AppBarSection>

          <AppBarSection>
            <LanguageSwitcher className="app-bar__language-switcher" />
          </AppBarSection>
        </>
      )}
    </AppBar>
  );
}
